// Admin detail for an admin account — info and their most recent activity. Rendered by UserDetailPage.
import { useFetch } from "../../hooks/useApi.js";
import DetailHeader from "../../components/admin/DetailHeader.js";
import DetailSection from "../../components/admin/DetailSection.js";
import InfoField from "../../components/admin/InfoField.js";
import ActivityFeedRow from "../../components/admin/ActivityFeedRow.js";
import { formatDate } from "../../lib/formatDateTime.js";
import type { AdminDetail, AdminUserRecord } from "@dm-lms/shared/types";

export default function AdminDetailPage({ user }: { user: Extract<AdminUserRecord, { role: "admin" }> }) {
  const { data, isLoading, error } = useFetch<AdminDetail>(`/api/admin/users/${user.id}/admin-detail`);
  const activity = data?.recentActivity ?? [];

  return (
    <div className="max-w-3xl space-y-6">
      <DetailSection header={<DetailHeader user={user} />}>
        <div className="grid grid-cols-2 gap-4 text-sm sm:grid-cols-3">
          <InfoField label="Admin code">{user.code}</InfoField>
          <InfoField label="Phone">{user.phone ?? "—"}</InfoField>
          <InfoField label="Member since">{formatDate(user.createdAt)}</InfoField>
        </div>
      </DetailSection>

      <DetailSection
        title="Recent activity"
        isLoading={isLoading}
        error={error}
        isEmpty={activity.length === 0}
        emptyText="No activity yet."
      >
        <div className="divide-y divide-gray-100">
          {activity.map((event) => (
            <ActivityFeedRow key={event.id} eventType={event.eventType} description={event.description} createdAt={event.createdAt} />
          ))}
        </div>
      </DetailSection>
    </div>
  );
}
